import { date, showAlert } from '../../../lib/helpers';
import { headers, search } from './attributes';


export default {
  data: () => ({
    show: false,
    view: false,
    options: {},
    dialogOtoM: false,
    dialogOtoOM: false,
    headers,
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    search,
    isFirstLoad: true,
    filterValue: {
      mid: '',
    },
    filterType: [
      { key: 'mid', type: 'textfield', props: { label: 'MID' } }
    ],
    alertConfig: {
      description: 'Tools untuk merubah Outlet menjadi Merchant Utama atau melakukan pindah Outlet ke Merchant lain',
      infoItems: [
        'Masukkan MID Outlet yang akan diproses menjadi Merchant Utama atau dipindahkan sebagai outlet Merchant lain'
      ]
    }
  }),

  computed: {
    errorValidation() {
      return this.$store.state.outletManagement.errors;
    },
    loading() {
      return this.$store.state.outletManagement.loading;
    },
    allData() {
      return this.$store.state.outletManagement.allData;
    },
    totalData() {
      return this.$store.state.outletManagement.totalData;
    },
    totalPage() {
      return this.$store.state.outletManagement.totalPage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('outletManagement/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    show(){
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  methods: {
    baseFilterData(newSearch) {
      this.search.mid = newSearch.mid || '';
      this.options.page = 1;
      this.getData(); 
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },

    clearSearch() {
      this.search.mid = '';
      this.$nextTick(() => {
        this.$store.commit('outletManagement/clearData');
      });
    },

    getData() {
      if (this.search.mid === '') {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'MID is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('outletManagement/clearData');
      } else {      const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('outletManagement/fetchMerchants', {
            date,
            page,
            itemsPerPage,
            search: this.search,
            merchantId: null,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });}
      
    },

    moveOutletToM(item) {
      const newItem = { ...item, user: { id: item.id } };
      this.editedIndex =
        this.$store.state.outletManagement.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialogOtoM = true;
    },

    moveOutletToOM(item) {
      const newItem = { ...item, user: { id: item.id } };
      this.editedIndex =
        this.$store.state.outletManagement.allData.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialogOtoOM = true;
    },

    close() {
      this.dialogOtoM = false;
      this.dialogOtoOM = false;

      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};